<template>
  <FullScreenModal :open="true" @close="$emit('close')">
    <h1 class="text-center font-extrabold text-xl">{{ t("title") }}</h1>

    <VeeForm v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
      <form @submit="handleSubmit($event, submitForm)" novalidate>
        <div class="grid grid-cols-2 gap-x-6 gap-y-4 mt-5">
          <FormField id="firstName" name="firstName" v-model="firstName" :label="t('first_name')" />
          <FormField id="lastName" name="lastName" v-model="lastName" :label="t('last_name')" />
          <FormField id="email" name="email" type="email" v-model="email" :label="t('email')" />
          <Selector
            id="role"
            name="role"
            v-model="role"
            :label="t('role')"
            :options="roleOptions"
            :defaultOptionText="t('role')"
          />
        </div>

        <div class="text-center mt-7 mb-5">
          <GenericButton type="submit" :disabled="saving">{{ t("submit") }}</GenericButton>
        </div>
      </form>
    </VeeForm>
  </FullScreenModal>
</template>

<script>
import { mapActions } from "vuex";
import { useI18n } from "vue-i18n";
import { Form as VeeForm } from "vee-validate";
import * as yup from "yup";
import { FullScreenModal, FormField, Selector, GenericButton } from "@estaly/ui";

export default {
  components: { FullScreenModal, FormField, Selector, GenericButton, VeeForm },

  emits: ["close", "created"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      role: "admin",
      saving: false,
      schema: yup.object({
        firstName: yup.string().required(),
        lastName: yup.string().required(),
        email: yup.string().email().required(),
      }),
    };
  },

  computed: {
    roleOptions() {
      return [
        { value: "admin", label: this.t("role_admin") },
        { value: "sales_manager", label: this.t("role_sales_manager") },
      ];
    },
  },

  methods: {
    ...mapActions("insurerManagers", { createInsurerManager: "create" }),

    async submitForm() {
      this.saving = true;
      try {
        const response = await this.createInsurerManager({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          role: this.role,
        });
        if (!response?.success) return;

        this.$emit("created");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<i18n src="./InsurerManagerFormModal.i18n.json"></i18n>
